import api from "@/api";
import {
  HistoryModel,
  NoticeModel,
  PageModel,
  PaginationModel,
} from "../types";

export default class HistoryApi {
  static async list(
    walletId: string,
    options:
      | {
          filter?: {
            role?: string[];
          };
        }
      | PaginationModel
  ): Promise<PageModel<HistoryModel>> {
    return await api.get(`history/wallet/${walletId}`, options);
  }

  static async single(id: string) {
    return await api.get(`history/${id}`);
  }

  static async total(
    options:
      | {
          filter?: {
            role?: string[];
          };
        }
      | PaginationModel
  ): Promise<PageModel<HistoryModel>> {
    return await api.get(`history/`, options);
  }
}
